export interface PurchaseHistoryEntry {
  readonly timestamp: number;
  readonly productId: string;
}

export type TokenTransactionReason = "tokenPack";

export interface TokenTransactionEntry {
  readonly timestamp: number;
  readonly delta: number;
  readonly reason: TokenTransactionReason;
  readonly productId?: string;
}

export interface RecordsState {
  readonly purchaseHistory: readonly PurchaseHistoryEntry[];
  readonly tokenTransactions: readonly TokenTransactionEntry[];
}

export const emptyRecordsState: RecordsState = {
  purchaseHistory: [],
  tokenTransactions: [],
};
